import { W2TInbox } from "../components/W2TApps";

/** /dashboard/inbox — the web2sms conversations (inbox) component on its own route. */
export function InboxPage() {
  return (
    <div className="col-main">
      <W2TInbox />
    </div>
  );
}
